import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getProjectById } from '../data/projectsData';
import { getTechIcon, getFeatureIcon } from '../utils/iconUtils';
import "../styles/project-details.css";

const ProjectDetails = () => {
    const { id } = useParams();
    const project = getProjectById(id);

    useEffect(() => {
        // Scroll to top when component mounts
        window.scrollTo(0, 0);

        // Update page title
        document.title = `${project?.title || 'Project'} - Portfolio`;

        // Redirect if project not found
        if (!project) {
            window.location.href = '/projects';
        }
    }, [project]);

    if (!project) return null;

    return (
        <div id="project-content">
            <article className="project-container">
                <div className="project-header">
                    <div className="header-top">
                        <Link to="/projects" className="back-link">
                            <i className="fas fa-arrow-left"></i>
                            Back to Projects
                        </Link>
                        <h1>{project.title}</h1>
                    </div>
                    <div className="project-meta">
                        <span>{project.category}</span>
                        <span className="dot">•</span>
                        <span>{project.date}</span>
                    </div>
                </div>

                <img src={project.imageUrl} alt={project.title} className="project-banner" />

                <div className="project-overview">
                    <p>{project.overview}</p>

                    <div className="project-links">
                        <a href={project.demoLink} className="button" target="_blank" rel="noopener noreferrer">
                            <i className="fas fa-external-link-alt"></i>
                            View Live
                        </a>
                        <a href={project.githubLink} className="button" target="_blank" rel="noopener noreferrer">
                            <i className="fab fa-github"></i>
                            Source Code
                        </a>
                    </div>
                </div>

                <section className="tech-stack">
                    <h2>Technologies</h2>
                    <ul>
                        {project.technologies.map((tech, index) => (
                            <li key={index}>
                                <i className={getTechIcon(tech)}></i>
                                <span>{tech}</span>
                            </li>
                        ))}
                    </ul>
                </section>

                <section className="features" style={{ marginTop: "1.5rem" }}>
                    <h2>Key Features</h2>
                    <div className="features-grid">
                        {project.features.map((feature, index) => (
                            <div key={index} className="feature">
                                <i className={getFeatureIcon(feature.title)}></i>
                                <h3>{feature.title}</h3>
                                <p>{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </section>

                {project.gallery.length > 0 ? (
                    <section className="gallery">
                        <h2>Gallery</h2>
                        <div className="gallery-grid">
                            {project.gallery.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt="Project Screenshot"
                                    loading="lazy"
                                />
                            ))}
                        </div>
                    </section>
                ) : null}
            </article>
        </div>
    );
};

export default ProjectDetails; 